import React, { useEffect } from 'react'
import { Col, Row } from 'antd'
import CountCircle from '../CountCircle/CountCircle';
import "../../../EmployerProfile/EmployerProfile.css";
import history from '../../../../../routes/history';
import { replaceGigWithJob } from '../../../../../shared/helpers';

const Cards = (props) => {

  const [windowDimensions, setWindowDimensions] = React.useState(
    getWindowDimensions()
  );
  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const goto = () => {
    history.push(props.goto)
  }
  return (
    <>
      {
        <Col className='main-card-div'>
          <div className='employer-profile-Card-content'>
            <Row justify='space-between'>
              <Col md={10} sm={12} xs={16} lg={12}>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <div className='employer-profile-interview-card-head'>{replaceGigWithJob(props.heading)}</div>
                  <div>
                    <CountCircle count={props.count} />
                  </div>
                </div>
              </Col>



              {windowDimensions.width < 768 ?
              ( 
                (((props.heading == 'My jobs') && props.count > 1)  ||  
                 ((props.heading != 'My jobs') && props.count > 2) 
                ) &&  
                  <Col md={3} xs={5} sm={5} lg={2} 
                      className={windowDimensions.width < 786 ?
                                  'seeAll-div' 
                                  :
                                  'seeAll-div-desktop'
                                }>
                        {
                          !props.seeAll &&
                          <div>
                            <div className='seeALl-text' onClick={goto}>
                              See all
                            </div>
                          </div>

                        }
                  </Col>
              )
              :
              (                
                  (((props.heading == 'My jobs') && props.count > 3)  ||  
                    ((props.heading != 'My jobs') && props.count > 4) 
                  ) &&  
                        <Col md={3} xs={5} sm={5} lg={2} 
                            className={windowDimensions.width < 786 ?
                                        'seeAll-div' 
                                        :
                                        'seeAll-div-desktop'
                                      }>
                              {
                                !props.seeAll &&
                                <div>
                                  <div className='seeALl-text' onClick={goto}>
                                    See all
                                  </div>
                                </div>

                              }
                        </Col>
                  
              )
              }
             
            </Row>
          </div>
          <div className='card-content'>
            {props.children ?? null}
          </div>
        </Col>
      }
    </>
  )
}
export default Cards; 